import {
  Breakpoint,
  useTheme,
  useMediaQuery
} from '@mui/material'
import {
  useEffect,
  useMemo
} from 'react'
import { createLogger } from '../app/logger'

const logger = createLogger({
  prefix: 'responsive-utils'
})

type ResponsiveInfo = {
  /**
   * May be null on first call
   */
  width: Breakpoint | null
  isMobile: boolean
}

const useWidth = () => {
  const theme = useTheme()

  let width: Breakpoint | null = null
  let matches: boolean
  let key: Breakpoint

  key = 'xl'
  matches = useMediaQuery(theme.breakpoints.up(key))
  width = matches ? key : width

  key = 'lg'
  matches = useMediaQuery(theme.breakpoints.up(key))
  width = !width && matches ? key : width

  key = 'md'
  matches = useMediaQuery(theme.breakpoints.up(key))
  width = !width && matches ? key : width

  key = 'sm'
  matches = useMediaQuery(theme.breakpoints.up(key))
  width = !width && matches ? key : width

  key = 'xs'
  matches = useMediaQuery(theme.breakpoints.up(key))
  width = !width && matches ? key : width

  useEffect(() => {
    logger.info('Updating responsive width: ', width)
  }, [width])

  return width
}

export const useResponsiveInfo = (): ResponsiveInfo => {
  const width = useWidth()
  const isMobile = useMemo(() => {
    const isMobile = width !== null && !(width === 'xl' || width === 'lg')
    return isMobile
  }, [width])
  const responsiveInfo = useMemo<ResponsiveInfo>(() => ({
    width,
    isMobile
  }), [isMobile, width])

  useEffect(() => {
    logger.info('Updating ResponsiveInfo: ', responsiveInfo)
  }, [responsiveInfo])

  return responsiveInfo
}
